import { PosService } from "../resource";

// POS หน้าร้าน (#443, spec 2026-10-10 §7) — namespace `Pos`.
// Holds the report-filter lookups (devices + events, B27) and the
// "tables not installed" flag every POS page shows as an alert.
const PosModule = {
    namespaced: true,
    state: {
        devices: [],
        events: [],
        lookupsLoaded: false,
        notInstalled: false
    },
    mutations: {
        SET_LOOKUPS(state, { devices, events }) {
            state.devices = devices || [];
            state.events = events || [];
            state.lookupsLoaded = true;
        },
        // false | "phase1" | "phase3"
        SET_NOT_INSTALLED(state, val) {
            state.notInstalled = val === true ? "phase1" : val || false;
        }
    },
    actions: {
        async fetchLookups({ state, commit }, force) {
            if (state.lookupsLoaded && !force) return state;
            try {
                const res = await PosService.PosLookups();
                const d = (res.data && res.data.Datum) || {};
                commit("SET_LOOKUPS", { devices: d.devices, events: d.events });
                commit("SET_NOT_INSTALLED", false);
            } catch (err) {
                const r = err && err.response;
                if (r && r.status === 503 && r.data && r.data.Msg === "pos_not_installed") {
                    commit("SET_NOT_INSTALLED", "phase1");
                } else if (r && r.status === 503 && r.data && r.data.Msg === "pos_phase3_not_installed") {
                    commit("SET_NOT_INSTALLED", "phase3");
                }
                throw err;
            }
            return state;
        },
        setNotInstalled({ commit }, val) {
            commit("SET_NOT_INSTALLED", val);
        }
    },
    getters: {
        devices: (state) => state.devices,
        events: (state) => state.events,
        notInstalled: (state) => state.notInstalled
    }
};

export default PosModule;
